import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function MasterAdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  if (user?.businessLevel !== 'MasterAdmin') {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
